module.exports = __webpack_public_path__ + "static/media/4b.1ac9cdb5.svg";